import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// --- PrimeNG ---
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { SkeletonModule } from 'primeng/skeleton';

// --- Overlay Panel ---
import { UnreadOrderMsgsPanelComponent } from './unread-order-msgs-panel.component';
import { ImageDefaultModule } from '@components/image-default/image-default.module';

@NgModule({
	declarations: [UnreadOrderMsgsPanelComponent],
	imports: [
		CommonModule,
		RouterModule,

		// --- PrimeNG ---
		ButtonModule,
		DividerModule,
		SkeletonModule,

		// --- Components ---
		ImageDefaultModule,
	],
	exports: [UnreadOrderMsgsPanelComponent],
})
export class UnreadOrderMsgsPanelModule {}
